'use strict';

/*global services*/

function roundNumber(num, dec) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
}

function formatNumber(number, decPoint, thousandsSep) {
    decPoint = decPoint || ',';
    thousandsSep = thousandsSep || ' ';

    var frac = String(number).split('.');
    frac[0] = String(frac[0]).split('').reverse().join('')
                  .replace(/(.{3}\B)/g, '$1' + thousandsSep)
                  .split('').reverse().join('');
          
    return frac.join(decPoint);
}

function formatPrice(price) {
    var currencyPrefixChr = services.get('configurations') ? services.get('configurations').param('CurrencyPrefixChr') : '';
    var currencySuffixChr = services.get('configurations') ? services.get('configurations').param('CurrencySuffixChr') : '';
    var decPoint = services.get('configurations') ? services.get('configurations').param('DecPoint') : ',';
    var thousandsSep = services.get('configurations') ? services.get('configurations').param('ThousandsSep') : ' ';

    return currencyPrefixChr + formatNumber(price.toFixed(2), decPoint, thousandsSep) + currencySuffixChr;
}
